'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var PropTypes = require('prop-types');

var SplitBannerContent = require('../SplitBannerContent/SplitBannerContent.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var SplitBannerContact = function SplitBannerContact(props) {
  var address_1 = props.address_1,
      address_2 = props.address_2,
      city = props.city,
      description = props.description,
      email = props.email,
      isHTML = props.isHTML,
      phone = props.phone,
      state = props.state,
      title = props.title,
      zip = props.zip;
  return /*#__PURE__*/React__default['default'].createElement(SplitBannerContent.SplitBannerContent, {
    title: title,
    description: description,
    isHTML: isHTML,
    className: "lanl-splitbanner-contact"
  }, /*#__PURE__*/React__default['default'].createElement("ul", {
    className: "contact-list"
  }, address_1 && /*#__PURE__*/React__default['default'].createElement("li", null, address_1), address_2 && /*#__PURE__*/React__default['default'].createElement("li", null, address_2), city && /*#__PURE__*/React__default['default'].createElement("li", null, city, ", ".concat(state), " ", zip), phone && /*#__PURE__*/React__default['default'].createElement("li", null, phone), email && /*#__PURE__*/React__default['default'].createElement("li", null, /*#__PURE__*/React__default['default'].createElement("a", {
    href: "mailto:".concat(email)
  }, email))));
};

SplitBannerContact.defaultProps = {};
SplitBannerContact.propTypes = {
  address_1: PropTypes__default['default'].string,
  address_2: PropTypes__default['default'].string,
  city: PropTypes__default['default'].string,
  className: PropTypes__default['default'].string,
  description: PropTypes__default['default'].string,
  email: PropTypes__default['default'].string,
  isHTML: PropTypes__default['default'].bool,
  phone: PropTypes__default['default'].string,
  state: PropTypes__default['default'].string,
  title: PropTypes__default['default'].string,
  zip: PropTypes__default['default'].number
};
exports.SplitBannerContact = SplitBannerContact;
exports['default'] = SplitBannerContact;